import React from 'react';
import { FormattedMessage } from 'react-intl';
import ModalAlert from '../../components/ui-toolkit/modal.js';
import { TertiaryButton } from '../../components/ui-toolkit/buttons.js';
import './delete-draft.modal.scss';

const DeleteDraftModal = ({
	openModal, deleteDraft, keepDraft,
}) => (
	<ModalAlert
		centered
		isOpen={openModal}
		className="delete-draft-modal"
	>
		<h1><FormattedMessage id="delete_draft_modal.delete_draft_title" /></h1>

		<p><FormattedMessage id="delete_draft_modal.delete_draft_confirm" /></p>

		<div className="d-flex justify-content-end">
			<TertiaryButton
				outline
				onClick={deleteDraft}
			>
				<FormattedMessage id="delete_draft_modal.delete_draft" />
			</TertiaryButton>

			<TertiaryButton onClick={keepDraft}>
				<FormattedMessage id="delete_draft_modal.keep_draft" />
			</TertiaryButton>
		</div>
	</ModalAlert>
);

export default DeleteDraftModal;
